import React from "react";
import "./EstModalStyles.scss";
import close from "../../../../assets/close.png";

interface EstModalProps {
  isOpen: boolean;
  onClose: () => void;
  waitEst?: string;
  setWaitEst?: React.Dispatch<React.SetStateAction<string>>;
  isEdit: boolean;
}

const EstModal: React.FC<EstModalProps> = ({
  isOpen,
  onClose,
  waitEst,
  setWaitEst,
  isEdit,
}) => {
  if (!isOpen) {
    return null;
  }

  const generateTimeIntervals = () => {
    const intervals: number[] = [];
    const totalMinutes = 15 * 60;

    for (let minutes = 0; minutes <= totalMinutes; minutes += 15) {
      if (minutes !== 0) {
        intervals.push(minutes);
      }
    }

    return intervals;
  };
  const formatTime = (minutes: number): string => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    return `${hours > 0 ? `${hours}h ` : ""}${
      remainingMinutes > 0 ? `${remainingMinutes} mins` : ""
    }`.trim();
  };

  return (
    <div className='est-modal-overlay' onClick={onClose}>
      <div
        className='est-modal-content'
        onClick={(e) => e.stopPropagation()}
        style={{ left: isEdit ? "37.2%" : "", top: isEdit ? "2rem" : "" }}
      >
        <div className='header'>
          <img alt='' src={close} onClick={onClose} />
        </div>
        <div className='content'>
          {generateTimeIntervals().map((item, index) => {
            return (
              <div
                className={`item-duration ${
                  waitEst
                    ? waitEst === formatTime(item)
                      ? "selected"
                      : ""
                    : ""
                }`}
                key={index}
                onClick={() => {
                  if (setWaitEst) {
                    setWaitEst(formatTime(item));
                  }
                  onClose();
                }}
              >
                <div className='gradient-text '>{formatTime(item)}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EstModal;
